import { Pipe, inject, type PipeTransform } from '@angular/core';
import { AuthService } from '@usheru-hff/authentication/domain';
import { CollectionRoutesEnum as Routes } from '@usheru-hff/shared/utils-community';

@Pipe({
  name: 'normalizeRoute',
  standalone: true
})
export class NormalizeRoutePipe implements PipeTransform {
  private readonly authService = inject(AuthService);
  transform(value: string, ...args: unknown[]): string {
    if (value?.includes(Routes.USER_ID)) {
      // replace route :username by the current user username
      return value?.replace(':' + Routes.USER_ID, this.authService.getUserUsername());
    }
    return value;
  }
}
